import { generateUUID } from '@wix/form-schema';
import { useMemo } from 'react';
export const dummyBi = {
    log: ()=>Promise.resolve(),
    report: ()=>Promise.resolve(),
    flush: ()=>Promise.resolve(),
    updateDefaults: ()=>dummyBi
};
export const useFormBi = (form, bi, biFormFillSessionId)=>{
    const formEditSessionId = useMemo(generateUUID, []);
    return useMemo(()=>{
        if (!bi) {
            return dummyBi;
        }
        return {
            ...bi,
            report: (payload)=>bi.report({
                    ...payload,
                    params: {
                        form_fill_session_id: biFormFillSessionId || formEditSessionId,
                        form_guid: form?.id,
                        form_schema_name: form.properties?.name,
                        form_url: location.href,
                        namespace: form.namespace,
                        ...payload?.params
                    }
                })
        };
    }, [
        bi,
        biFormFillSessionId,
        form?.id,
        form.namespace,
        form.properties?.name,
        formEditSessionId
    ]);
};

//# sourceMappingURL=use-form-bi.js.map